/* eslint-disable */
export default {
    error_page_not_found: "Page introuvable !",
    error_page_not_found_title: "Page introuvable",
    error_page_not_found_body: "La page que vous avez demandée est introuvable.",
    error_ltpimpact_landing_title: "Ce service n’est plus disponible",
    error_ltpimpact_landing_content: "Ce site n’est hélas plus accessible. Contacter le Service Client de LTP à l’adresse <a href=\"mailto:online@ltp.nl\">online@ltp.nl</a> ou au numéro +31 (0)20 30 50 438."
};
